<svg
	width="100%"
	height="100%"
	viewBox="0 0 24 24"
	stroke-width="1.5"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	stroke="currentColor"
	color="currentColor"
>
	<title>Muted volume</title>
	<g clip-path="url(#clip0_3173_16686)"
		><path
			d="M18 14L20.0005 12M22 10L20.0005 12M20.0005 12L18 10M20.0005 12L22 14"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/><path
			d="M2 13.8571V10.1429C2 9.03829 2.89543 8.14286 4 8.14286H6.9C7.09569 8.14286 7.28708 8.08544 7.45046 7.97772L13.4495 4.02228C14.1144 3.5839 15 4.06075 15 4.85714V19.1429C15 19.9392 14.1144 20.4161 13.4495 19.9777L7.45046 16.0223C7.28708 15.9146 7.09569 15.8571 6.9 15.8571H4C2.89543 15.8571 2 14.9617 2 13.8571Z"
			stroke-width="1.5"
		/></g
	><defs
		><clipPath id="clip0_3173_16686"
			><rect width="24" height="24" fill="white" /></clipPath
		></defs
	></svg
>
